import { gql } from "@apollo/client";
import { useMemo } from "react";

import { ORG_ID } from "../../orgs";

import { useGetOrgStatusesForSidebarQuery } from "./useHasLibraryStatuses.generated";

gql`
  query GetOrgStatusesForSidebar($orgId: OrgId!) {
    orgById(orgId: $orgId) {
      id
      statuses {
        id
        inLibrary
        endorsed
      }
    }
  }
`;

export const useHasLibraryStatuses = (): boolean => {
  const { data: statusesData } = useGetOrgStatusesForSidebarQuery({
    variables: { orgId: ORG_ID },
  });
  const hasLibraryStatuses = useMemo(
    () =>
      (statusesData?.orgById.statuses ?? []).filter(
        (s) => s.inLibrary || s.endorsed,
      ).length > 0,
    [statusesData],
  );
  return hasLibraryStatuses;
};
